import React from 'react';
import { Icon, Reveal, Section } from '@/components/ui';
import { resumeContent } from '@/content/resume';

/**
 * Projects section for the résumé/portfolio product variant (§11). See
 * `src/pages/ResumeDemo.tsx`.
 */
const ResumeProjects: React.FC = () => {
    return (
        <Section id="resume-projects" className="resume-projects" title="Projects" contained>
            <div className="resume-projects-grid">
                {resumeContent.projects.map((project, index) => (
                    <Reveal
                        as="div"
                        className="resume-project card"
                        key={project.title}
                        delay={index * 100}
                    >
                        <h3 className="resume-project-title">{project.title}</h3>
                        <p className="resume-project-description">{project.description}</p>
                        {project.href && (
                            <a className="resume-project-link" href={project.href}>
                                View project <Icon name="arrow-right" />
                            </a>
                        )}
                    </Reveal>
                ))}
            </div>
        </Section>
    );
};

export default ResumeProjects;
